import React, { useEffect, useState } from "react";
import { Badge, Card, Table } from "react-bootstrap";
import { TabView, TabPanel } from "primereact/tabview";
import { Accordion, AccordionTab } from "primereact/accordion";
import NumberFormat from "react-number-format";
import BootstrapTooltip from "../../../../../../partials/content/BootstrapTooltip";
import CustomDataTable from "../../../../../../partials/content/CustomDataTable";
import DialogLayout from "../../../../../../partials/content/DialogLayout";
import { DialogActions, Typography } from "@material-ui/core";
import Illustration from "../../../../../../partials/content/Illustration";
import {
  CustomOutlinedDisabledCurrencyField,
  CustomOutlinedDisabledTextField,
} from "../../../../../../partials/content/Forms";
import ResponsiveEllipsis from "../../../../../../partials/content/ResponsiveEllipsis";
import { getVisitDirectSales } from "../../../../../../services/crm/salesJourney";
import { formatDate } from "../../../../../../utils/utils";
import CustomPrintOutInvoice from "../../../../../../partials/content/CustomPrintOutInvoice";
import { useGlobalData } from "../../../../../../../provider/GlobalDataProvider";
function DirectSalesDetail({ directSalesID = 0 }) {
  const { reload } = useGlobalData();
  const [directSales, setDirectSales] = useState({
    customer: {
      customerName: "",
    },
    currency: {
      currencyCode: "",
    },
    payMethodName: "",
    exchangeRate: 1,
    directSalesItem: [],
    directSalesAddCost: [],
  });
  const [activeIndex, setActiveIndex] = useState(0);
  const [openPrintLayout, setOpenPrintLayout] = useState(false);
  const [invoice, setInvoice] = useState({ ID: 0 });
  const [invoices, setInvoices] = useState([]);

  async function getDirectSalesData(directSalesID) {
    const invoiceTmp = [];
    const response = await getVisitDirectSales(directSalesID);
    const { data } = response.data;
    setDirectSales(data.directSales);

    invoiceTmp.push(data.directSales.invoice);
    setInvoices(invoiceTmp);
  }

  useEffect(() => {
    getDirectSalesData(directSalesID);
  }, [directSalesID, reload]);
  return (
    <React.Fragment>
      <div className="tabview">
        <div className="card">
          <TabView className="tabview" scrollable>
            <TabPanel header="Direct Sales Main" rightIcon="fas fa-th-large">
              <div className="row mb-3">
                <div className="col-sm-12 col-md-12 col-lg-12">
                  <Card>
                    <Card.Header>
                      <i className="fas fa-window-maximize"></i>
                      <span>
                        <strong>Direct Sales Header</strong>
                      </span>
                    </Card.Header>
                    <Card.Body>
                      <div className="row">
                        <div className="col-sm-4 col-md-4 col-lg-4">
                          <CustomOutlinedDisabledTextField
                            label="Customer Name"
                            value={directSales.customer.customerName}
                          />
                          <CustomOutlinedDisabledTextField
                            label="Currency"
                            value={directSales.currency.currencyCode}
                          />
                          <CustomOutlinedDisabledTextField
                            label="Exchange Rate To Base Currency"
                            value={directSales.exchangeRate}
                          />
                        </div>
                        <div className="col-sm-4 col-md-4 col-lg-4">
                          <CustomOutlinedDisabledTextField
                            label="Sales Date"
                            value={formatDate(directSales.salesDate)}
                          />
                          <CustomOutlinedDisabledTextField
                            label="Pay Method"
                            value={directSales.payMethodName}
                          />

                          {directSales.payMethod === 4 ? (
                            <CustomOutlinedDisabledTextField
                              label="Deadline Date"
                              value={formatDate(directSales.deadlineDate)}
                            />
                          ) : null}
                        </div>
                        <div className="col-sm-4 col-md-4 col-lg-4">
                          <CustomOutlinedDisabledCurrencyField
                            label="Sub Total"
                            value={directSales.subTotal}
                          />
                          <div className="row">
                            <div className="col-sm-6 col-md-6 col-lg-6">
                              <CustomOutlinedDisabledCurrencyField
                                label="Discount Amount"
                                value={directSales.discountAmount}
                              />
                            </div>
                            <div className="col-sm-6 col-md-6 col-lg-6">
                              <CustomOutlinedDisabledCurrencyField
                                label="Tax Amount"
                                value={directSales.taxAmount}
                              />
                            </div>
                          </div>
                          <CustomOutlinedDisabledCurrencyField
                            label="Grand Total"
                            value={directSales.grandTotal}
                          />
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </div>
              </div>
              <div className="accordion">
                <div className="card">
                  <Accordion
                    className="accordion"
                    activeIndex={activeIndex}
                    onTabChange={(e) => setActiveIndex(e.index)}
                  >
                    <AccordionTab
                      header={
                        <React.Fragment>
                          <i className="fas fa-sitemap"></i>
                          <span>
                            <strong>Direct Sales Items</strong>
                          </span>
                        </React.Fragment>
                      }
                    >
                      <div className="row">
                        <div className="col-sm-12 col-md-12 col-lg-12">
                          <div className="row mb-3">
                            <div className="col-sm-12 col-md-12 col-lg-12">
                              <div className="card">
                                <Table
                                  striped
                                  borderless
                                  size="sm"
                                  responsive="xl"
                                >
                                  <thead>
                                    <tr>
                                      <th style={{ width: "30%" }}>
                                        <Typography className="mx-1 kt-font-bolder">
                                          Item Name
                                        </Typography>
                                      </th>
                                      <th style={{ width: "5%" }}>
                                        <Typography className="mx-1 kt-font-bolder">
                                          Quantity
                                        </Typography>
                                      </th>
                                      <th style={{ width: "10%" }}>
                                        <Typography className="mx-1 kt-font-bolder">
                                          Unit
                                        </Typography>
                                      </th>
                                      <th style={{ width: "20%" }}>
                                        <Typography className="mx-1 kt-font-bolder text-right">
                                          Unit Price
                                        </Typography>
                                      </th>
                                      <th style={{ width: "15%" }}>
                                        <Typography className="mx-1 kt-font-bolder text-right">
                                          Item Discount
                                        </Typography>
                                      </th>
                                      <th style={{ width: "20%" }}>
                                        <Typography className="mx-1 kt-font-bolder text-right">
                                          Total Price
                                        </Typography>
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {directSales.directSalesItem.map(
                                      (item, index) => (
                                        <tr key={index} className="border-top">
                                          <td>
                                            <Typography className="mx-1 my-1">
                                              {item.itemType > 0 ? (
                                                <span>
                                                  <BootstrapTooltip
                                                    title={item.itemTypeName}
                                                  >
                                                    <span className="mr-2">
                                                      <i
                                                        className={
                                                          item.itemType === 1
                                                            ? "fas fa-boxes text-success"
                                                            : item.itemType ===
                                                              2
                                                            ? "fas fa-tools text-primary"
                                                            : item.itemType ===
                                                              3
                                                            ? "fas fa-building text-info"
                                                            : item.itemType ===
                                                              4
                                                            ? "fas fa-boxes text-warning"
                                                            : item.itemType ===
                                                              5
                                                            ? "fas fa-boxes text-danger"
                                                            : null
                                                        }
                                                      ></i>
                                                    </span>
                                                  </BootstrapTooltip>
                                                  <span>
                                                    {item.itemCode}{" "}
                                                    {item.itemName}
                                                  </span>
                                                </span>
                                              ) : (
                                                <React.Fragment>
                                                  {item.itemCode}{" "}
                                                  {item.itemName}
                                                </React.Fragment>
                                              )}
                                            </Typography>
                                          </td>
                                          <td>
                                            <Typography className="mx-1 my-1">
                                              {item.qty}
                                            </Typography>
                                          </td>
                                          <td>
                                            <Typography className="mx-1 my-1">
                                              {item.uomName}
                                            </Typography>
                                          </td>
                                          <td>
                                            <Typography
                                              component="div"
                                              className="mx-1 my-1"
                                            >
                                              <NumberFormat
                                                value={item.unitPrice}
                                                displayType={"text"}
                                                thousandSeparator={true}
                                                decimalScale={2}
                                                renderText={(value) => (
                                                  <div className="float-right">
                                                    {directSales.currencyCode}{" "}
                                                    {value}
                                                  </div>
                                                )}
                                              />
                                            </Typography>
                                          </td>
                                          <td>
                                            <Typography
                                              component="div"
                                              className="mx-1 my-1"
                                            >
                                              <NumberFormat
                                                value={item.discountAmount}
                                                displayType={"text"}
                                                thousandSeparator={true}
                                                decimalScale={2}
                                                renderText={(value) => (
                                                  <div className="float-right">
                                                    {directSales.currencyCode}{" "}
                                                    {value}
                                                  </div>
                                                )}
                                              />
                                            </Typography>
                                          </td>
                                          <td>
                                            <Typography
                                              component="div"
                                              className="mx-1 my-1"
                                            >
                                              <NumberFormat
                                                value={item.totalPrice}
                                                displayType={"text"}
                                                thousandSeparator={true}
                                                decimalScale={2}
                                                renderText={(value) => (
                                                  <div className="float-right">
                                                    {directSales.currencyCode}{" "}
                                                    {value}
                                                  </div>
                                                )}
                                              />
                                            </Typography>
                                          </td>
                                        </tr>
                                      )
                                    )}
                                  </tbody>
                                </Table>
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-sm-6 col-md-6 col-lg-6 mb-3 mb-md-0">
                              <Card>
                                <Card.Body>
                                  <div className="card">
                                    <Table
                                      striped
                                      borderless
                                      size="sm"
                                      responsive="xl"
                                    >
                                      {directSales.directSalesAddCost &&
                                      directSales.directSalesAddCost.length >
                                        0 ? (
                                        <thead>
                                          <tr>
                                            <th style={{ width: "60%" }}>
                                              <Typography className="mx-1 kt-font-bolder">
                                                Cost Name
                                              </Typography>
                                            </th>
                                            <th style={{ width: "40%" }}>
                                              <Typography className="mx-1 kt-font-bolder">
                                                Cost Price
                                              </Typography>
                                            </th>
                                          </tr>
                                        </thead>
                                      ) : null}
                                      <tbody>
                                        {directSales.directSalesAddCost &&
                                        directSales.directSalesAddCost.length >
                                          0 ? (
                                          directSales.directSalesAddCost.map(
                                            (item, index) => {
                                              return (
                                                <tr
                                                  key={index}
                                                  className="border-top"
                                                >
                                                  <td>
                                                    <Typography className="mx-1 my-1">
                                                      {item.itemName}
                                                    </Typography>
                                                  </td>
                                                  <td>
                                                    <Typography
                                                      component="div"
                                                      className="mx-1 my-1"
                                                    >
                                                      <NumberFormat
                                                        value={item.costPrice}
                                                        displayType={"text"}
                                                        thousandSeparator={true}
                                                        decimalScale={2}
                                                        renderText={(value) => (
                                                          <div className="float-right">
                                                            {
                                                              directSales.currencyCode
                                                            }{" "}
                                                            {value}
                                                          </div>
                                                        )}
                                                      />
                                                    </Typography>
                                                  </td>
                                                </tr>
                                              );
                                            }
                                          )
                                        ) : (
                                          <tr>
                                            <td
                                              className="text-center"
                                              colSpan="2"
                                            >
                                              <Illustration
                                                guidance="No additional cost"
                                                guidanceLeftIcon="fas fa-info-circle kt-font-success"
                                              ></Illustration>
                                            </td>
                                          </tr>
                                        )}
                                      </tbody>
                                    </Table>
                                  </div>
                                </Card.Body>
                                <Card.Footer>
                                  <Table borderless size="sm" responsive="xl">
                                    <tbody>
                                      <tr>
                                        <td style={{ width: "50%" }}>
                                          <Typography className="kt-font-bolder">
                                            Additional Cost Total
                                          </Typography>
                                        </td>
                                        <td style={{ width: "0%" }}></td>
                                        <td style={{ width: "0%" }}></td>
                                        <td style={{ width: "50%" }}>
                                          <Typography
                                            component="div"
                                            className="kt-font-bolder"
                                          >
                                            <NumberFormat
                                              value={directSales.addCostTotal}
                                              displayType={"text"}
                                              thousandSeparator={true}
                                              decimalScale={2}
                                              renderText={(value) => (
                                                <div className="float-right">
                                                  {directSales.currencyCode}{" "}
                                                  {value}
                                                </div>
                                              )}
                                            />
                                          </Typography>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </Table>
                                </Card.Footer>
                              </Card>
                            </div>
                            <div className="col-sm-6 col-md-6 col-lg-6">
                              <Card>
                                <Card.Body className="pb-0">
                                  <Table borderless size="sm" responsive="xl">
                                    <tbody>
                                      <tr className="border-bottom">
                                        <td style={{ width: "50%" }}>
                                          <Typography className="mb-3 kt-font-bolder">
                                            Sub Total
                                          </Typography>
                                        </td>
                                        <td style={{ width: "0%" }}></td>
                                        <td style={{ width: "0%" }}></td>
                                        <td style={{ width: "50%" }}>
                                          <Typography
                                            component="div"
                                            className="mb-3 kt-font-bolder"
                                          >
                                            <NumberFormat
                                              value={directSales.subTotal}
                                              displayType={"text"}
                                              thousandSeparator={true}
                                              decimalScale={2}
                                              renderText={(value) => (
                                                <div className="float-right">
                                                  {directSales.currencyCode}{" "}
                                                  {value}
                                                </div>
                                              )}
                                            />
                                          </Typography>
                                        </td>
                                      </tr>
                                      <tr className="border-bottom">
                                        <td>
                                          <Typography
                                            component="div"
                                            className="my-3"
                                          >
                                            <NumberFormat
                                              value={
                                                directSales.discountPercent
                                              }
                                              displayType={"text"}
                                              thousandSeparator={true}
                                              decimalScale={2}
                                              renderText={(value) => (
                                                <div>
                                                  Discount{" ("}
                                                  {value}
                                                  {"%)"}
                                                </div>
                                              )}
                                            />
                                          </Typography>
                                        </td>
                                        <td></td>
                                        <td></td>
                                        <td>
                                          <Typography
                                            component="div"
                                            className="my-3"
                                          >
                                            <NumberFormat
                                              value={directSales.discountAmount}
                                              displayType={"text"}
                                              thousandSeparator={true}
                                              decimalScale={2}
                                              renderText={(value) => (
                                                <div className="float-right">
                                                  - {directSales.currencyCode}{" "}
                                                  {value}
                                                </div>
                                              )}
                                            />
                                          </Typography>
                                        </td>
                                      </tr>
                                      <tr className="border-bottom">
                                        <td>
                                          <Typography
                                            component="div"
                                            className="my-3"
                                          >
                                            <NumberFormat
                                              value={directSales.taxPercent}
                                              displayType={"text"}
                                              thousandSeparator={true}
                                              decimalScale={2}
                                              renderText={(value) => (
                                                <div>
                                                  Tax{" ("}
                                                  {value}
                                                  {"%)"}
                                                </div>
                                              )}
                                            />
                                          </Typography>
                                        </td>
                                        <td></td>
                                        <td></td>
                                        <td>
                                          <Typography
                                            component="div"
                                            className="my-3"
                                          >
                                            <NumberFormat
                                              value={directSales.taxAmount}
                                              displayType={"text"}
                                              thousandSeparator={true}
                                              decimalScale={2}
                                              renderText={(value) => (
                                                <div className="float-right">
                                                  {directSales.currencyCode}{" "}
                                                  {value}
                                                </div>
                                              )}
                                            />
                                          </Typography>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <Typography className="my-3">
                                            Additional Cost
                                          </Typography>
                                        </td>
                                        <td></td>
                                        <td></td>
                                        <td>
                                          <Typography
                                            component="div"
                                            className="my-3"
                                          >
                                            <NumberFormat
                                              value={directSales.addCostTotal}
                                              displayType={"text"}
                                              thousandSeparator={true}
                                              decimalScale={2}
                                              renderText={(value) => (
                                                <div className="float-right">
                                                  {
                                                    directSales.currency
                                                      .currencyCode
                                                  }{" "}
                                                  {value}
                                                </div>
                                              )}
                                            />
                                          </Typography>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </Table>
                                </Card.Body>
                                <Card.Footer>
                                  <Table borderless size="sm" responsive="xl">
                                    <tbody>
                                      <tr>
                                        <td style={{ width: "50%" }}>
                                          <Typography
                                            variant="h6"
                                            className="kt-font-bolder"
                                          >
                                            Grand Total
                                          </Typography>
                                        </td>
                                        <td style={{ width: "0%" }}></td>
                                        <td style={{ width: "0%" }}></td>
                                        <td style={{ width: "50%" }}>
                                          <Typography
                                            variant="h6"
                                            component="div"
                                            className="kt-font-bolder"
                                          >
                                            <NumberFormat
                                              value={directSales.grandTotal}
                                              displayType={"text"}
                                              thousandSeparator={true}
                                              decimalScale={2}
                                              renderText={(value) => (
                                                <div className="float-right">
                                                  {directSales.currencyCode}{" "}
                                                  {value}
                                                </div>
                                              )}
                                            />
                                          </Typography>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </Table>
                                </Card.Footer>
                              </Card>
                            </div>
                          </div>
                        </div>
                      </div>
                    </AccordionTab>
                  </Accordion>
                </div>
              </div>
            </TabPanel>
            <TabPanel header="Invoices" rightIcon="fas fa-file-invoice-dollar">
              <CustomDataTable
                data={invoices}
                onRefreshData={() => {
                  getDirectSalesData(directSalesID);
                }}
                columns={[
                  {
                    header: "A/R Invoice ID",
                    field: "ID",
                    body: null,
                    sortable: true,
                    filter: true,
                  },
                  {
                    header: "Document Reference",
                    field: "docRefDesc",
                    body: (rowData) => (
                      <React.Fragment>
                        <ResponsiveEllipsis
                          text={rowData.docRefDesc}
                          maxLine="1"
                        />
                      </React.Fragment>
                    ),
                    sortable: true,
                    filter: true,
                  },
                  {
                    header: "Payment Status",
                    field: "paymentStatus",
                    body: (rowData) => {
                      if (rowData.paymentStatus === 1) {
                        return (
                          <Badge variant="danger">
                            {rowData.paymentStatusDesc}
                          </Badge>
                        );
                      } else if (rowData.paymentStatus === 2) {
                        return (
                          <Badge variant="warning">
                            {rowData.paymentStatusDesc}
                          </Badge>
                        );
                      } else if (rowData.paymentStatus === 3) {
                        return (
                          <Badge variant="success">
                            {rowData.paymentStatusDesc}
                          </Badge>
                        );
                      } else {
                        return (
                          <Badge variant="dark">
                            {rowData.paymentStatusDesc}
                          </Badge>
                        );
                      }
                    },
                    sortable: true,
                    filter: true,
                  },
                  {
                    header: "Invoice Date",
                    field: "invoiceDate",
                    body: (rowData) => formatDate(rowData.invoiceDate),
                    sortable: true,
                    filter: true,
                  },
                  {
                    header: "Currency",
                    field: "currency.currencyCode",
                    body: null,
                    sortable: true,
                    filter: true,
                    hidden: true,
                  },
                  {
                    header: "Amount",
                    field: "grandTotal",
                    body: (rowData) => (
                      <NumberFormat
                        value={rowData.grandTotal}
                        displayType={"text"}
                        thousandSeparator={true}
                        decimalScale={2}
                        renderText={(value) => (
                          <div className="float-right">
                            {rowData.currency.currencyCode} {value}
                          </div>
                        )}
                      />
                    ),
                    sortable: true,
                    filter: true,
                  },
                  {
                    header: "Actions",
                    body: (rowData) => (
                      <BootstrapTooltip title="Account Receivable Invoice PrintOut">
                        <button
                          type="button"
                          onClick={() => {
                            setInvoice(rowData);
                            setOpenPrintLayout(true);
                          }}
                          className="btn btn-icon btn-label-info btn-circle btn-md mx-1"
                        >
                          <i className="fas fa-print"></i>
                        </button>
                      </BootstrapTooltip>
                    ),
                    sortable: false,
                  },
                ]}
              />
            </TabPanel>
          </TabView>
        </div>
      </div>
      <DialogLayout
        open={openPrintLayout}
        title="A/R Invoice PrintOut"
        onCloseDialog={() => {
          setOpenPrintLayout(false);
        }}
        maxWIdth="lg"
      >
        <CustomPrintOutInvoice invoiceID={invoice.ID} />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenPrintLayout(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
    </React.Fragment>
  );
}

export default DirectSalesDetail;
